/* @flow */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

class Profile extends Entity {
  urlRoot() {
    return '/profiles';
  }

  defaults() {
    return {
      needs: {},
    };
  }

  getNeeds(): Object {
    return this.get('needs');
  }

  needsPassword(): boolean {
    return !!this.getNeeds().password;
  }

  needsFullName(): boolean {
    return !!this.getNeeds().full_name;
  }

  static fetchByIdentifier(identifier: string): Promise<Profile> {
    return apiRequest('/profiles', 'GET', { user_identifier: identifier })
      .then(profile => Profile.fromJSON(profile));
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/entities/Profile.js